/** Prefer closed-deal unit, then under-consideration unit. */
export function getLeadAssociatedUnit(lead) {
  return lead?.deal?.unit || lead?.underConsideration?.unit || null;
}

export function getLeadAssociatedUnitLabel(lead) {
  const unit = getLeadAssociatedUnit(lead);
  if (!unit) {
    const fallback = lead?.preferred_unit?.trim();
    return fallback || '---';
  }

  const blockName = unit?.block?.name?.trim() || '';
  const unitName = (unit?.unitName || unit?.name || '').trim();
  const combined = [blockName, unitName].filter(Boolean).join(' ');
  return combined || '---';
}
